import type { ReactNode } from 'react';

import styles from '@/components/book/PageTitle.module.css';
import { titleSize } from '@/lib/book/titles';

interface PageTitleProps {
  title: string;
  /** Drawn in the `h1` in place of `title` when the heading carries markup, e.g. `<KnowellName />`; `title` still sizes it. */
  display?: ReactNode;
  /** Above the title, usually a `<Crumb>`. */
  crumb?: ReactNode;
  /** Italic summary, e.g. a shelf's own summary. */
  summary?: ReactNode;
  /** The counts sentence under the title. */
  lede?: ReactNode;
  className?: string;
}

/** A page's head: crumb, `h1`, summary and lede (DESIGN-SPEC §4 PageHead). Long titles step down. */
export function PageTitle({ title, display, crumb, summary, lede, className }: PageTitleProps) {
  return (
    <header className={[styles.head, className].filter(Boolean).join(' ')}>
      {crumb}
      <h1 className={styles.title} data-size={titleSize(title) || undefined}>{display ?? title}</h1>
      {summary != null && <p className={styles.summary}>{summary}</p>}
      {lede != null && <p className={styles.lede}>{lede}</p>}
    </header>
  );
}
